module.exports = __webpack_public_path__ + "img/dashboard-check-account-balance-bm.e3111622.png";